export const byName = (a, b) =>
   a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;

export const byNumber = (a, b) =>
   a.number.toLowerCase() > b.number.toLowerCase() ? 1 : -1;
